const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocalProtocols(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    cx: 16.663,
    cy: 14.85,
    r: 1.912
  }), /*#__PURE__*/React.createElement("polyline", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeMiterlimit: 10
    },
    points: "15.707,14.85  16.185,15.328 17.619,14.372  "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M12.589,2.55v-0.3c0-0.4,0-0.6-0.5-0.7 c-0.1,0-0.1,0-0.2,0l-7.6,3l8.2,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M13.589,3.45v-0.3c0-0.4-0.2-0.7-0.5-0.7h-0.1 l-8.3,2.1l8.9,0.1"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.489,4.65v-0.5c0-0.4-0.3-0.7-0.6-0.7h-0.1 l-9.5,1.1L14.489,4.65z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10
    },
    d: " M15.389,17.65c0.1,0.2-0.2,0.5-0.4,0.5h-10.9c-0.3,0-0.5-0.2-0.5-0.5V5.15c0-0.3,0.2-0.5,0.5-0.5h10.8c0.3,0,0.5,0.2,0.5,0.5v7"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.189,12.35h-9.1c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.289,12.35,14.289,12.35,14.189,12.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.189,13.75h-9.1c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.289,13.65,14.289,13.75,14.189,13.75z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.189,15.05h-9.1c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.289,15.05,14.289,15.05,14.189,15.05z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M14.189,16.45h-9.1c-0.1,0-0.1-0.1-0.1-0.1l0,0 c0-0.1,0.1-0.1,0.1-0.1h9.1c0.1,0,0.1,0.1,0.1,0.1l0,0C14.289,16.35,14.289,16.45,14.189,16.45z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "da0xAf.tif"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.392,10.953 c0.007-0.007,0.012-0.012,0.016-0.018c0.435-0.541,0.848-1.099,1.213-1.69c0.194-0.315,0.37-0.64,0.508-0.985 c0.125-0.312,0.156-0.629,0.081-0.958c-0.18-0.787-0.833-1.366-1.639-1.446C9.173,5.817,8.8,5.897,8.458,6.103 C7.956,6.406,7.649,6.848,7.55,7.429C7.528,7.561,7.519,7.695,7.537,7.828c0.022,0.159,0.07,0.31,0.129,0.459 C7.8,8.629,7.98,8.947,8.173,9.258c0.317,0.511,0.672,0.995,1.041,1.469C9.273,10.802,9.332,10.877,9.392,10.953z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none",
      stroke: "#2C355E",
      strokeWidth: 0.25,
      strokeMiterlimit: 10
    },
    d: "M9.39,6.819c0.521,0,0.945,0.424,0.944,0.944 C10.333,8.282,9.91,8.704,9.391,8.704c-0.52,0-0.945-0.424-0.944-0.944C8.448,7.241,8.871,6.819,9.39,6.819z M9.967,7.762 c0-0.317-0.257-0.576-0.573-0.577c-0.321-0.001-0.58,0.257-0.58,0.577c0,0.319,0.259,0.577,0.576,0.578 C9.708,8.339,9.967,8.08,9.967,7.762z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocalProtocols);
export default __webpack_public_path__ + "static/media/local_protocols.533afdec35a9d73cc831fc954f3868a4.svg";
export { ForwardRef as ReactComponent };